<template>
  <form @submit.prevent="submit">
    <div class="register-top">
      <div>
        <h2 class="mb-6">{{ $t('register.not_me.title') }}</h2>
        <v-alert :value="success" dense text type="success">
          {{ $t('register.not_me.success') }}
        </v-alert>
        <v-alert :value="error" dense text type="error">
          {{ $t('register.not_me.error') }}
        </v-alert>
        <v-text-field
          v-model="firstname"
          required
          :label="$t('register.not_me.firstname')"
          dense
        ></v-text-field>
        <v-text-field
          v-model="lastname"
          :label="$t('register.not_me.lastname')"
          required
          dense
        ></v-text-field>
        <v-text-field
          v-model="profession"
          :label="$t('register.not_me.profession')"
          required
          dense
        ></v-text-field>
        <v-text-field
          v-model="email"
          :label="$t('register.not_me.email')"
          required
          dense
        ></v-text-field>
        <v-text-field
          v-model="phone"
          :label="$t('register.not_me.phone')"
          required
          dense
        ></v-text-field>
      </div>
    </div>
    <div class="register-bottom">
      <register-base-button
        gradient="linear-gradient(90deg, #5A46C7 0%, #208DC5 100%)"
      >
        {{ $t('register.not_me.send') }}
      </register-base-button>
      <br />
      <a @click.prevent="$router.go(-1)" class="register-link">
        {{ $t('register.not_me.back') }}
      </a>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  data() {
    return {
      firstname: '',
      lastname: '',
      profession: '',
      email: '',
      phone: '',
      success: false,
      error: false
    }
  },
  methods: {
    submit() {
      axios
        .post(
          process.env.VUE_APP_API + '/webform_rest/submit?_format=json',
          {
            webform_id: 'not_me',
            firstname: this.firstname,
            lastname: this.lastname,
            profession: this.profession,
            email: this.email,
            phone: this.phone
          },
          { withCredentials: true }
        )
        .then(() => {
          this.success = true
          this.firstname = ''
          this.lastname = ''
          this.profession = ''
          this.email = ''
          this.phone = ''
        })
        .catch(() => {
          this.error = true
        })
    }
  },
  components: {
    RegisterBaseButton
  }
}
</script>
